import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import Header from "./components/header";
import firstSection from "./components/FirstSection";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
